<template>
  <!-- 审批 -->
  <div class="apply-reason-memo">
    <html-content :content="content" />
  </div>
</template>

<script>
import HtmlContent from './HtmlContent.vue'

export default {
  name: 'ApplyReasonRemarkView',
  props: ['content'],
  methods: {},
  components: {
    HtmlContent,
  },
}
</script>

<style lang="less" scoped>
.apply-reason-memo {
  margin: 20px 0;
}
.attachment-list {
  display: block;
  margin-top: 10px;
  margin-left: -30px;
  li {
    list-style: none;
  }
}
</style>
